module.exports = __webpack_public_path__ + "static/media/x.2cc45365.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/appletv-icons/x.svg
// module id = 638
// module chunks = 0